import debounce from 'lodash.debounce';
import { store } from 'store/store';
import { mediaDevicesChangeStarted } from 'features/user-media/actions';
import { logger } from 'utils/logger';
import { addDeviceChangeListener, removeDeviceChangeListener } from 'features/user-media/utils';

export class DeviceChangeMonitorClass {
  // A remove/re-add pair folds into one window that enumerates unchanged; the count exposes it.
  private eventsInWindow = 0;

  private isActive = false;

  private settleWindow = debounce(() => {
    const devicechangeEvents = this.eventsInWindow;
    this.eventsInWindow = 0;
    store.dispatch(mediaDevicesChangeStarted({ devicechangeEvents }));
  }, 300);

  private handleDeviceChange = () => {
    this.eventsInWindow += 1;
    this.settleWindow();
  };

  start = () => {
    if (this.isActive) {
      return;
    }

    addDeviceChangeListener(this.handleDeviceChange);
    this.isActive = true;

    logger
      .remote({ system: true, capture: 'media-devices' })
      .info('[DeviceChangeMonitor] Started monitoring device changes in room');
  };

  stop = () => {
    if (!this.isActive) {
      return;
    }

    removeDeviceChangeListener(this.handleDeviceChange);
    this.settleWindow.cancel();
    this.eventsInWindow = 0;
    this.isActive = false;

    logger
      .remote({ system: true, capture: 'media-devices' })
      .info('[DeviceChangeMonitor] Stopped monitoring device changes in room');
  };

  isMonitoring = () => this.isActive;
}

export const DeviceChangeMonitor = new DeviceChangeMonitorClass();
